// @flow
import * as React from 'react';
import Helmet from 'react-helmet';

import { AuthWrapper } from '../../statsradio/modules/authentication/login/styles';
import { LoginCard, LoginSection, Logo } from '../modules/authentication/styles';

interface Props {
  background: string,
  title: string,
  logo: string,

  children?: any;
}

export default function BackgroundPage({ background, title, logo, children }: Props) {
  return (
    <AuthWrapper background={background}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <LoginCard zDepth={5}>
        <LoginSection>
          <Logo
            src={logo}
            alt="logo"
          />
          {children}
        </LoginSection>
      </LoginCard>
    </AuthWrapper>
  );
}



// WEBPACK FOOTER //
// ./src/common/components/BackgroundPage.js